module.exports = __webpack_public_path__ + "img/slide-3.e787e016.png";